import React, { useEffect, useState } from 'react';

import { FormPermissoes } from '../../components/FormPermissoes';
import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';
import { Skeleton } from 'primereact/skeleton';
import MenuMain from '../../MenuMain';

import { AppFooter } from '../../AppFooter';

import api from '../../api/api';

export default function EditarPermissoesPage(props) {

    const [grupo, setGrupo] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [errorGettingGrupo, setErrorGettingGrupo] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [idGrupo] = useState(props.match.params.id)


    const getGrupo = async (id) => {
        setIsLoading(true);

        try {
            const response = await api.get(`grupoPermissoes/${id}`);

            setGrupo({
                'id': response.data.id,
                'nome': response.data.nome,
                'permissoes': response.data.permissoes,
            })

            setErrorGettingGrupo(false)
        }
        catch (error) {
            setErrorMessage(error.toString())
            setErrorGettingGrupo(true)
        }

        setIsLoading(false);
    }

    useEffect(() => {
        getGrupo(idGrupo)
    }, [])

    return (
        <>
            <MenuMain>
    {
        isLoading || !grupo ? (
            <Skeleton width="100%" height="100px" />
        ) : errorGettingGrupo ? (
            <ErrorRetrievingData
                errorMessage={errorMessage}
                retrieveFunction={() => getGrupo(idGrupo)}
                isLoading={isLoading}
            />
        ) : (
            <FormPermissoes
                defaultValues={grupo}
                isEditing={true}
                isLoading={isLoading}
            />
        )
    }
</MenuMain>

            <AppFooter />
        </>
    );
}
